import React from 'react';
import { AlertOctagon, ExternalLink, ReceiptPoundSterling } from 'lucide-react';
import { Button } from '@/components/ui/button';

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');
const INV_LABEL = { DRAFT: 'Draft in Xero', SUBMITTED: 'Awaiting approval', AUTHORISED: 'Awaiting payment', PAID: 'Paid', VOIDED: 'Voided', DELETED: 'Deleted' };

/** Hosting invoice chip + take-down warning + raise button for one website-log row. */
export function HostingInvoiceCell({ e, onRaise, onTakeDown }) {
  if (e.status !== 'live' && !e.unpaid_overdue) return null;
  const inv = e.hosting_invoice;
  const open = inv && ['DRAFT', 'SUBMITTED', 'AUTHORISED'].includes(inv.status);
  return (
    <div className="mt-2 space-y-1.5" data-testid={`wl-hosting-${e.id}`}>
      {inv?.xero_invoice_id && (
        <a href={inv.url} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full border ${inv.status === 'PAID' ? 'bg-emerald-50 text-emerald-800 border-emerald-200' : 'bg-gray-50 text-gray-700 border-gray-200'} hover:underline`} data-testid={`wl-invoice-${e.id}`}>
          <ReceiptPoundSterling className="w-3 h-3" /> {inv.number || 'Invoice'} · £{Number(inv.amount || 0).toFixed(2)} · {INV_LABEL[inv.status] || inv.status}{inv.status === 'PAID' && inv.paid_at ? ` ${fmt(inv.paid_at)}` : ''} <ExternalLink className="w-3 h-3" />
        </a>
      )}
      {e.unpaid_overdue && (
        <div className="flex flex-wrap items-center gap-2 bg-rose-50 border border-rose-300 rounded-lg px-2.5 py-1.5" data-testid={`wl-unpaid-${e.id}`}>
          <span className="inline-flex items-center gap-1 text-xs font-bold text-rose-800"><AlertOctagon className="w-3.5 h-3.5" /> Hosting unpaid since {fmt(inv.period_start)} — site should be taken down</span>
          <Button size="sm" variant="outline" onClick={() => onTakeDown(e)} className="h-7 text-rose-800 border-rose-300 hover:bg-rose-100" data-testid={`wl-takedown-${e.id}`}>Mark taken down</Button>
        </div>
      )}
      {e.status === 'live' && !open && (
        <Button size="sm" variant="outline" onClick={() => onRaise(e)} className="h-7 text-teal-800 border-teal-300 hover:bg-teal-50" data-testid={`wl-raise-invoice-${e.id}`}><ReceiptPoundSterling className="w-3.5 h-3.5 mr-1" /> Raise hosting invoice</Button>
      )}
    </div>
  );
}
